import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { ConfigurationParser } from "@/models/admin/configuration/configuration.parser"
import { GetConfigurationsQuery } from "@/api/hasura/generated/graphql"

class ConfigurationsServiceClass {
  getConfigurationsAdminList() {
    return useQuery({
      ...HasuraQueries.configuration.list(),
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data: GetConfigurationsQuery) => {
        if (!data?.configuration) return []
        return data.configuration.map((data) =>
          ConfigurationParser.toDomain(data),
        )
      },
    })
  }
}

export const ConfigurationsService = new ConfigurationsServiceClass()
